import React from 'react';
import { ExclamationTriangleIcon, CheckCircleIcon } from '@heroicons/react/24/outline';
import { useAuthStore } from '../../stores/useAuthStore';

export const UserSetupValidation: React.FC = () => {
  const { userSetupValidation } = useAuthStore();

  if (!userSetupValidation) {
    return null;
  }

  if (userSetupValidation.isComplete) {
    return (
      <div className="bg-green-50 border border-green-200 rounded-md p-4 mb-4">
        <div className="flex">
          <div className="flex-shrink-0">
            <CheckCircleIcon className="h-5 w-5 text-green-400" />
          </div>
          <div className="ml-3">
            <h3 className="text-sm font-medium text-green-800">
              Configuración Completa
            </h3>
            <div className="mt-2 text-sm text-green-700">
              <p>Tu cuenta está configurada correctamente y lista para usar.</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const getIssueMessage = (issue: string) => {
    switch (issue) {
      case 'no_companies':
      case 'empresa_incomplete':
        return 'Tu cuenta no está asociada a ninguna empresa. Contacta al administrador para completar la configuración.';
      case 'no_current_company':
        return 'Selecciona una empresa para continuar o completa la configuración inicial.';
      case 'no_user':
        return 'No se pudo validar la configuración del usuario.';
      default:
        return 'Hay un problema con la configuración de tu cuenta.';
    }
  };

  return (
    <div className="bg-yellow-50 border border-yellow-200 rounded-md p-4 mb-4">
      <div className="flex">
        <div className="flex-shrink-0">
          <ExclamationTriangleIcon className="h-5 w-5 text-yellow-400" />
        </div>
        <div className="ml-3">
          <h3 className="text-sm font-medium text-yellow-800">
            Configuración Incompleta
          </h3>
          <div className="mt-2 text-sm text-yellow-700">
            <ul className="list-disc pl-5 space-y-1">
              {userSetupValidation.issues.map((issue, index) => (
                <li key={index}>{getIssueMessage(issue)}</li>
              ))}
            </ul>
          </div>
          <div className="mt-4">
            <div className="-mx-2 -my-1.5 flex">
              <button
                type="button"
                className="bg-yellow-50 px-2 py-1.5 rounded-md text-sm font-medium text-yellow-800 hover:bg-yellow-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-yellow-50 focus:ring-yellow-600"
                onClick={() => window.location.reload()}
              >
                Reintentar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

